import React, { Component } from 'react'
import { Redirect, Link } from 'react-router-dom'
import { connect } from 'react-redux'

import Grid from '@material-ui/core/Grid'
import { withStyles } from '@material-ui/core/styles'
import {
  Button,
  Paper,
  Typography,
  Hidden
} from '@material-ui/core'
import { verifyInviteToken, setPassword, checkLoggedin } from '../actions/users'
import queryString from 'query-string'
import colors from '../helpers/color.helper'
import util from '../helpers/util.helper'
import { Check } from '@material-ui/icons'
import i18n from '../i18n'

import Password from './register/formComponents/password'

const styles = theme => ({
  container: {
    overflow: 'hidden',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundImage: 'url(/shapes-lines-large.svg)',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'calc(50% - 257px) calc(50% - 214px)',
    [theme.breakpoints.down('sm')]: {
      minHeight: 450,
      backgroundSize: '1104.75px 1089.75px'
    },
    [theme.breakpoints.up('sm')]: {
      minHeight: 760
    },
    [theme.breakpoints.down('xs')]: {
      backgroundSize: '736.5px 726.5px',
      backgroundPosition: 'top right'
    }
  },
  form: {
    flex: 1,
    [theme.breakpoints.down('xs')]: {
      paddingTop: '14vh'
    }
  },
  logo: {
    position: 'absolute',
    [theme.breakpoints.up('lg')]: {
      // top: 240,
      // left: 241,
      top: '20vh',
      left: '11vw',
      height: 51,
      width: 235
    },
    [theme.breakpoints.down('lg')]: {
      // top: 200,
      // left: 201,
      top: '19.53125vh',
      left: '14.71449487554905vw',
      height: 51,
      width: 235
    },
    [theme.breakpoints.down('md')]: {
      // top: 100,
      // left: 100.8,
      top: '13.15789473684211vh',
      left: '9.84375vw',
      height: 38.3,
      width: 176.3
    },
    [theme.breakpoints.down('sm')]: {
      // top: 50,
      // left: 75.8,
      top: '8.333333333333333vh',
      left: '9.475vw',
      height: 38.3,
      width: 176.3
    },
    [theme.breakpoints.down('xs')]: {
      position: 'inherit',
      height: 38.3,
      width: 176.3
    }
  },
  paper: theme.mixins.gutters({
    width: 520,
    background: 'none',
    boxShadow: 'none',
    [theme.breakpoints.down('xs')]: {
      width: 295
    }
  }),
  welcome: {
    color: colors.blue
  },
  lock: {
    position: 'relative',
    bottom: 30,
    left: -36,
    [theme.breakpoints.down('xs')]: {
      display: 'none'
    }
  },
  link: {
    textDecoration: 'none',
    color: colors.blue
  },
  visibility: {
    opacity: 0.5,
    height: 16,
    width: 16
  },
  icon: {
    height: 16,
    width: 16
  },
  password: {
    [theme.breakpoints.down('xs')]: {
      '& input': {
        paddingLeft: 48
      }
    }
  },
  passwordFocused: {
    [theme.breakpoints.down('xs')]: {
      '& input': {
        paddingLeft: 48
      }
    },
    '& input': {
      color: `${colors.blue} !important`
    }
  },
  loading: {
    color: colors.white,
    height: '16px !important',
    width: '16px !important'
  },
  success: {
    height: 48,
    width: 48,
    backgroundColor: colors.success,
    borderRadius: '50%',
    marginLeft: 165
  },
  tick: {
    height: 24,
    width: 24,
    color: colors.white,
    margin: 12
  },
  containerPassword: {
    justifyContent: 'space-between',
    flexWrap: 'no-wrap'
  },
  submitButton: {
    width: 154
  },
  submitPassword: {
    paddingLeft: 45,
    paddingTop: 16
  },
  descriptionContainer: {
    marginBottom: 24,
    marginLeft: 45,
    maxWidth: 427
  },
  description: {
    fontSize: 15
  }
})

class SetPassword extends Component {
  initState = {
    password: '',
    confirmPassword: '',
    passwordError: true,
    confirmPasswordError: true,
    isVerificationComplete: false
  }

  state = this.initState
  constructor (props) {
    super(props)
    this.classes = props.classes
  }

  componentDidMount () {
    const { match: { params } } = this.props
    this.query = this.props.location.search
    if (this.props.forceUpdate) {
      this.props.checkLoggedin().then(() => {
        if (!this.props.self.user.is_force_reset_password) {
          window.location.href = util.forwardClientQueryStringToPath('/login', this.query)
          return
        }
        this.setState({ isVerificationComplete: true })
      }, err => {
        this.setState({ isVerificationComplete: false })
        window.location.href = util.forwardClientQueryStringToPath('/login', this.query)
        console.error(err)
      })
    } else {
      this.props.verifyInviteToken(params.token)
        .then(() => {
          this.setState({ isVerificationComplete: true })
        }).catch(() => {
          this.setState({ isVerificationComplete: true })
        })
    }
    this.params = queryString.parse(this.query)
  }

  handleSubmit = (e) => {
    e.preventDefault()
    const { match: { params } } = this.props

    if (this.state.password !== this.state.confirmPassword) {
      this.setState({ error: { confirmPassword: 'Does not match' } })
    } else {
      this.props.setPassword(params.token, this.state.password, this.state.confirmPassword)
    }
  }

  onChange = (e) => {
    const state = this.state
    state[e.target.name] = e.target.value
    this.setState(state)
  }

  onPasswordChange = (value, error) => {
    this.setState({ password: value, passwordError: error })
  }

  onConfirmPasswordChange = (value, error, passwordError) => {
    // Password again always update on the next tick to avoid condition when password change
    // We have checking to rerun password again check upon password change
    setTimeout(() => {
      this.setState({ confirmPassword: value, error: passwordError !== undefined })
      if (passwordError !== undefined) {
        this.setState({ passwordError, confirmPasswordError: error })
      } else {
        this.setState({ confirmPasswordError: error })
      }
    }, 0)
  }

  handlePreventSubmit = e => {
    e.preventDefault()
    e.stopPropagation()
  }

  render () {
    const { classes, forceUpdate } = this.props
    const self = this.props.self || {}
    const { password, confirmPassword, passwordError, confirmPasswordError } = this.state
    self.error = self.error || {}

    if (self.isPasswordSetSuccessful) {
      return <Redirect to={util.forwardClientQueryStringToPath('/login', this.query)} />
    }

    if (!this.state.isVerificationComplete) {
      return null
    }

    return (
      <>
        <div id='set-password' className={classes.container}>
          <Grid
            container
            spacing={0}
            className={classes.form}
            alignItems='center'
            direction='column'
            justify='center'
          >
            <Grid item container justify='center'>
              <Link to='/'><img src='/black.svg' alt='SmarterWX Identity Logo' className={classes.logo} /></Link>
            </Grid>

            <Grid item xs={11} sm={6} md={6} lg={4} xl={4}>
              {
                self.isVerificationSuccessful || forceUpdate
                  ? (
                    <Paper elevation={4} className={classes.paper}>
                      <Grid container direction='row' style={{ marginBottom: 32, marginLeft: 45 }}>
                        <Hidden only='xs'>
                          <Typography variant='h6' className={classes.welcome}>{i18n.verifyTokenPage.title1}</Typography>
                          <span>&nbsp;&nbsp;</span>
                          <Typography variant='h6'>{i18n.verifyTokenPage.title2}</Typography>
                        </Hidden>
                      </Grid>
                      {forceUpdate &&
                        <Grid container direction='row' className={classes.descriptionContainer}>
                          <Hidden only='xs'>
                            <Typography className={classes.description}>{i18n.verifyTokenPage.description}</Typography>
                          </Hidden>
                        </Grid>}
                      <form onSubmit={this.handleSubmit}>
                        <Grid container direction='column' justify='space-between'>
                          <form onSubmit={this.handlePreventSubmit}>
                            <Password
                              arrangeInput='column'
                              passwordChange={this.onPasswordChange}
                              passwordAgainChange={this.onConfirmPasswordChange}
                              passwordValue={password}
                              passwordAgainValue={confirmPassword}
                              minScore={3}
                            />
                          </form>
                          <Grid container justify='space-between' className={this.classes.submitPassword}>
                            <Button variant='contained' className={classes.submitButton} color='primary' type='submit' disabled={self.isProcessing || passwordError || confirmPasswordError}>{i18n.verifyTokenPage.button}</Button>
                            {
                              self.isPasswordSetSuccessful &&
                                <div className={classes.success}><Check className={classes.tick} /></div>
                            }
                          </Grid>
                        </Grid>
                      </form>
                    </Paper>
                    )
                  : (
                    <Paper item elevation={4} className={this.classes.paper}>
                      <Typography variant='subtitle1'>{i18n.verifyTokenPage.fail}</Typography>
                      <Typography variant='subtitle1'>
                        <Link to={{ pathname: '/login', search: this.props.location.search }}>
                          {i18n.verifyTokenPage.returnLink}
                        </Link>
                      </Typography>
                    </Paper>
                    )
              }
            </Grid>
          </Grid>
        </div>
      </>
    )
  }
}

const SetPasswordComponent = withStyles(styles)(SetPassword)

// Whatever is returned will show up as props inside props of this component
function mapStateToProps (state) {
  return { self: state.self }
}

// Promote SetPassword from a component to a container - it needs to know about this new dispatch method.
export default connect(mapStateToProps, { verifyInviteToken, setPassword, checkLoggedin })(SetPasswordComponent)
